import { UserExceptionStatus } from "@/common/constants/gql-exception.constant";
import {
  ApolloClient,
  ApolloLink,
  // HttpLink,
  split,
  from,
} from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { enqueueSnackbar } from "notistack";
import { cache } from "./cache";
import { typeDefs } from "./local/schema";
import { accessTokenVar } from "./variables";

type ServerException = {
  status: number;
  description: string;
};

const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_HTTP_URL,
});

// const httpLink = new HttpLink({
//   uri: process.env.REACT_APP_HTTP_URL,
// });

const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.REACT_APP_WEBSOCKET_URL!,
  })
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  uploadLink
);

const authLink = new ApolloLink((operation, forward) => {
  const access_token = localStorage.getItem("access_token");
  operation.setContext(({ headers }: { headers: Record<string, string> }) => ({
    headers: {
      authorization: access_token ? `Bearer ${access_token}` : undefined,
      ...headers,
    },
  }));
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      enqueueSnackbar(message || "服务器繁忙", {
        preventDuplicate: true,
        variant: "error",
      });
      // Sentry.captureMessage(message);
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
    const exceptions: ServerException[] = graphQLErrors.map(
      (item) => item?.extensions.exception as ServerException
    );
    const isUnauthorized = exceptions.some(
      (item) => item?.status === UserExceptionStatus.USER_UNAUTHORIZED
    );
    if (isUnauthorized) {
      accessTokenVar(undefined);
      localStorage.removeItem("access_token");
    }
  }

  if (networkError) {
    // Sentry.captureException(networkError);
    enqueueSnackbar("服务器繁忙", { preventDuplicate: true, variant: "error" });
    console.log(`[Network error]: ${networkError}`);
  }
});

export const client = new ApolloClient({
  resolvers: {},
  typeDefs,
  cache,
  link: from([authLink, errorLink, splitLink]),
  connectToDevTools: true,
});
